import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Select"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "select"
    }}>{`Select`}</h1>
    <p>{`Form select component`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import { Select, Box } from 'theme-ui'
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-js",
        "metastring": "live=true",
        "live": "true"
      }}>{`<Select defaultValue="Hello">
  <option>Hello</option>
  <option>Hi</option>
  <option>Beep</option>
  <option>Boop</option>
</Select>
`}</code></pre>
    <h2 {...{
      "id": "variants"
    }}>{`Variants`}</h2>
    <p>{`Select variants can be defined in `}<inlineCode parentName="p">{`theme.forms`}</inlineCode>{` and the component uses the
`}<inlineCode parentName="p">{`theme.forms.select`}</inlineCode>{` variant by default.`}</p>
    <h2 {...{
      "id": "custom-arrow-icon"
    }}>{`Custom arrow icon`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live=true",
        "live": "true"
      }}>{`<Select
  arrow={
    <Box
      as="svg"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentcolor"
      sx={{
        ml: -28,
        alignSelf: 'center',
        pointerEvents: 'none',
      }}>
      <path d="M7.41 7.84l4.59 4.58 4.59-4.58 1.41 1.41-6 6-6-6z" />
    </Box>
  }
  defaultValue="Hello">
  <option>Hello</option>
  <option>Hi</option>
  <option>Beep</option>
  <option>Boop</option>
</Select>
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      